<template>
  <div class="row retroactive-payments">
    <div class="col-12">
      <div class="retroactive-payments__header">
        <span class="retroactive-payments__icon">
          <em class="fas fa-file-invoice" />
        </span>
        <span class="retroactive-payments__title">
          Consulta de Pagos Retroactivos
        </span>
      </div>
    </div>

    <div class="col-12 mt-2">
      <div class="retroactive-payments__question">
        ¿La consulta tiene autorizado pagos retroactivos?
      </div>
      <custom-radio
        v-model="selectedRetroactivePaymentAuthorization"
        class="w-75 retroactive-payments__radio"
        custom-error-msg="Favor marque sí o no."
        disabled
        is-inline
        name="hasRetroactivePaymentAuthorization"
        :options="yesNoOptions"
      />
    </div>

    <template v-if="hasRetroactivePaymentAuthorization === true">
      <div class="col-12 mt-2">
        <div class="retroactive-payments__label">
          Justificación de pago retroactivo:
        </div>
        <div class="retroactive-payments__text">
          {{ model.retroactivePaymentJustification || '-' }}
        </div>
      </div>

      <div class="col-12 mt-3">
        <div class="retroactive-payments__header">
          <span class="retroactive-payments__icon">
            <em class="fas fa-file-plus" />
          </span>
          <span class="retroactive-payments__title">
            Documentos que sustentan pago retroactivo
          </span>
        </div>

        <div
          v-if="!retroactivePaymentDocuments.length"
          class="retroactive-payments__empty mt-3"
        >
          No hay documentos registrados para este pago retroactivo.
        </div>

        <div
          v-for="(document, index) in retroactivePaymentDocuments"
          :key="document.documentId || `retroactive-payment-document-${index}`"
          class="retroactive-payments__document mt-3"
        >
          <div class="row align-items-center">
            <div class="col-12 col-md-6">
              <div class="retroactive-payments__label">
                Nombre del Documento:
              </div>
              <div class="retroactive-payments__text">
                {{ documentTypeName(document) }}
              </div>
            </div>
            <div class="col-12 col-md-5 mt-3 mt-md-0">
              <div class="retroactive-payments__label">
                Archivo:
              </div>
              <div class="retroactive-payments__text">
                {{ documentFilename(document) }}
              </div>
            </div>
            <div class="col-12 col-md-1 text-right mt-3 mt-md-0">
              <action-button
                class="retroactive-payments__download"
                class-icon="mr-0"
                i="fas fa-file-download"
                variant="success"
                @click="onDownload(document)"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
import CustomRadio from 'custom-radio';
import _generalApi from '@/modules/app/api.js';
import alert from '@/mixins/alert.mixin';

const normalizeBoolean = (value) => {
  if (value === true || value === false) return value;
  if (value === 1 || value === '1' || value === 'true') return true;
  if (value === 0 || value === '0' || value === 'false') return false;
  return null;
};

export default {
  name: 'RetroactivePayments',
  components: {
    CustomRadio,
  },
  mixins: [alert],
  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
    readonly: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      yesNoOptions: [
        {
          id: 1,
          name: 'yes',
          label: 'Sí',
          value: true,
          disabled: true,
        },
        {
          id: 2,
          name: 'no',
          label: 'No',
          value: false,
          disabled: true,
        },
      ],
    };
  },
  computed: {
    model: {
      get() {
        return this.value || {};
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    hasRetroactivePaymentAuthorization: {
      get() {
        return normalizeBoolean(this.model.hasRetroactivePaymentAuthorization);
      },
      set() {},
    },
    selectedRetroactivePaymentAuthorization: {
      get() {
        return this.yesNoOptions.find(
          (option) => option.value === this.hasRetroactivePaymentAuthorization
        );
      },
      set() {},
    },
    retroactivePaymentDocuments() {
      return this.model.retroactivePaymentDocuments || [];
    },
    documentTypeName() {
      return (document) =>
        document?.documentType?.name ||
        document?.documentTypeName ||
        document?.document?.documentTypeName ||
        '-';
    },
    documentFilename() {
      return (document) =>
        document?.filename ||
        document?.fileName ||
        document?.documentName ||
        document?.document?.filename ||
        '-';
    },
  },
  methods: {
    async onDownload(document) {
      if (!document?.documentId) {
        this.ShowToast('', 'El documento no existe.', 'error');
        return;
      }

      try {
        await _generalApi.downloadDocumentByAttachmentId(document.documentId);
      } catch {
        this.ShowToast('', 'El documento no existe.', 'error');
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.retroactive-payments {
  color: #1f2d3d;
  padding: 16px 8px 20px;
}

.retroactive-payments__header {
  align-items: center;
  display: flex;
}

.retroactive-payments__icon {
  align-items: center;
  background-color: #fff;
  border-radius: 50%;
  box-shadow: 0 2px 7px rgba(31, 45, 61, 0.15);
  color: #ff5b5c;
  display: inline-flex;
  font-size: 11px;
  height: 18px;
  justify-content: center;
  margin-right: 12px;
  width: 18px;
}

.retroactive-payments__icon em {
  background: transparent !important;
  border-radius: 0 !important;
  box-shadow: none !important;
  color: #ff5b5c !important;
  font-size: 11px;
  height: auto;
  line-height: 1;
  width: auto;
}

.retroactive-payments__title {
  color: #1f2d3d;
  font-size: 13px;
  font-weight: 700;
}

.retroactive-payments__label {
  color: #727272;
  font-size: 12px;
  line-height: 18px;
}

.retroactive-payments__text {
  color: #1f2d3d;
  font-size: 13px;
  line-height: 18px;
  white-space: pre-wrap;
}

.retroactive-payments__question {
  color: #6f7b7d;
  font-size: 12px;
  font-weight: 400;
  line-height: 18px;
  margin-bottom: 4px;
}

.retroactive-payments__radio ::v-deep {
  .col-12 {
    padding-left: 0;
    padding-right: 0;
  }

  .custom-control {
    min-height: 18px;
    padding-left: 1.25rem;
  }

  .custom-control-inline {
    margin-right: 12px;
  }

  .custom-control-label {
    color: #1f2d3d;
    font-size: 13px;
    line-height: 18px;
  }

  .custom-control-label::before,
  .custom-control-label::after {
    height: 14px;
    left: -1.25rem;
    top: 2px;
    width: 14px;
  }

  .custom-control-input:disabled:checked ~ .custom-control-label::before {
    background-color: #3f5b60 !important;
    border-color: #3f5b60 !important;
  }
}

.retroactive-payments__document {
  background-color: #f8f8f8;
  padding: 16px 18px;
}

.retroactive-payments__empty {
  color: #727272;
  font-size: 13px;
  font-weight: 700;
  padding: 12px 0;
}

::v-deep .retroactive-payments__download {
  align-items: center;
  border-radius: 4px;
  display: inline-flex;
  height: 40px;
  justify-content: center;
  min-width: 40px !important;
  padding: 0 !important;
  width: 40px;
}

::v-deep .retroactive-payments__download i {
  color: #fff !important;
  display: inline-block;
  font-family: FontAwesome, 'Font Awesome 5 Free' !important;
  font-size: 18px;
  font-weight: 900;
  line-height: 1;
  margin: 0 !important;
}
</style>
